import axios from "axios";
import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import logo from "../assets/logo.png";
import Loader from "../Shared/Loader";
import { endpoint } from "../utils/APIRoutes";
import { country_code } from "../utils/countryCode";

const Registration = () => {
  const [loading, setLoading] = useState(false);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [mobile, setMobile] = useState("");
  const [mt5AccountId, setMt5AccountId] = useState("12345");
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmpassword] = useState("");
  // const [invitationcode, setInvitationcode] = useState("");
  const [sponsername, setSponsername] = useState("");
  const [searchParams] = useSearchParams();
  const referral_id = searchParams.get("startapp") || null;

  // const params = window?.Telegram?.WebApp?.initDataUnsafe?.start_param;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const countryCodeOptions = useMemo(() => {
    const options = (country_code || []).flatMap((item) => {
      const root = item?.idd?.root || "";
      const suffixes = item?.idd?.suffixes?.length ? item.idd.suffixes : [""];

      return suffixes.map((suffix) => ({
        value: `${root}${suffix || ""}`,
        countryName: item?.name?.common || "",
        cca2: item?.cca2 || "",
        flagPng: item?.flags?.png || "",
      }));
    });

    const uniqueMap = new Map();
    options.forEach((option) => {
      if (option?.value && !uniqueMap.has(option.value)) {
        uniqueMap.set(option.value, option);
      }
    });

    return Array.from(uniqueMap.values()).sort((a, b) =>
      a.countryName.localeCompare(b.countryName)
    );
  }, []);

  const selectedCountry = countryCodeOptions.find((item) => item?.value === countryCode) || null;



  const loginFn = async (reqBody) => {
    setLoading(true);

    if (password !== confirmpassword) {
      toast.error("Passwords do not match.");
      setLoading(false);
      return;
    }

    const reqBodyy = {
      mobile: String(mobile || "").trim(),
      country_code: String(countryCode)?.toLowerCase(),
      email: String(email)?.toLocaleLowerCase(),
      full_name: `${firstname} ${lastname}`.trim() || "N/A",
      referral_id: String(referral_id),
      password: String(password),
      mt_id: String(mt5AccountId),
    };

    try {
      const response = await axios.post(endpoint?.registration_api, reqBodyy, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      });

      setLoading(false);

      if (response?.data?.success) {
        // dispatch(saveUid(reqBodyy?.mobile));
        // dispatch(saveToken(response?.data?.result?.[0]?.token));
        // dispatch(saveUsername(reqBodyy?.username));
        // dispatch(saveUserCP(response?.data?.result?.[0]?.isCP));
        // localStorage.setItem("logindataen", response?.data?.result?.[0]?.token);
        // localStorage.setItem("uid", reqBodyy?.mobile);
        // localStorage.setItem("username", reqBodyy?.username);
        // localStorage.setItem("isCP", response?.data?.result?.[0]?.isCP);

        Swal.fire({
          title: "🎉 Congratulations!",
          html: `
            <p style="font-size:14px; margin-bottom:8px;">${response?.data?.message}</p>
            <p style="font-size:12px; color:#555;">Your account has been successfully created. You can now login to your account.</p>

          `,
          icon: "success",
          confirmButtonColor: "black",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/login");
            window.location.reload();
          }
        });
        // toast(response?.data?.message);
        // navigate("/dashboard");
        // window.location.reload();
      } else {
        Swal.fire({
          text: response?.data?.message,
          icon: "warning",
          confirmButtonColor: "black",
        });
        // toast(response?.data?.message);
      }
    } catch (error) {
      toast("Error during registration.");
      setLoading(false);
    }
  };


  const getSponserName = async () => {
    try {
      const response = await axios.post(
        endpoint?.get_spon_name,
        { customer_id: referral_id },
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      if (response?.data?.success) {
        // setSponsername(response?.data?.result?.[0]?.lgn_name);
        setSponsername("true");
      } else {
        setSponsername("Invalid Sponser");
      }
    } catch (error) {
      setSponsername("Error fetching sponser");
    }
  };

  useEffect(() => {
    if (referral_id) {
      getSponserName();
    }
  }, [referral_id]);

  return (
    <>
      <Loader isLoading={loading} />

      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#060E1C] via-[#080F1C] to-[#060E1C] relative overflow-hidden">
        {/* Enhanced animated background effects */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(37,99,235,0.2),transparent_50%)]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_80%,rgba(37,99,235,0.18),transparent_50%)]"></div>

        {/* Multiple floating orbs */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-r from-[#2563EB]/20 to-[#2563EB]/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-l from-[#2563EB]/20 to-[#2563EB]/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/4 w-64 h-64 bg-gradient-to-br from-[#2563EB]/10 to-[#2563EB]/10 rounded-full blur-2xl animate-pulse" style={{ animationDelay: '2s' }}></div>

        {/* Website-style grid background */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage: `
              linear-gradient(rgba(37,99,235,0.08) 1px, transparent 1px),
              linear-gradient(90deg, rgba(37,99,235,0.08) 1px, transparent 1px)
            `,
            backgroundSize: '40px 40px',
          }}
        ></div>

        {/* Enhanced floating particles */}
        <div className="absolute top-20 left-20 w-3 h-3 bg-gradient-to-r from-[#2563EB] to-[#2563EB] rounded-full opacity-80 animate-ping"></div>
        <div className="absolute bottom-40 right-32 w-2 h-2 bg-gradient-to-r from-[#2563EB] to-[#2563EB] rounded-full opacity-70 animate-ping" style={{ animationDelay: '1.5s' }}></div>
        <div className="absolute top-1/3 right-1/4 w-1 h-1 bg-[#2563EB] rounded-full opacity-60 animate-ping" style={{ animationDelay: '2.5s' }}></div>
        <div className="absolute bottom-1/3 left-1/3 w-2 h-2 bg-[#2563EB] rounded-full opacity-50 animate-ping" style={{ animationDelay: '3s' }}></div>

        {/* Registration Card */}
        <div className="relative z-10 w-full max-w-md mx-1">
          {/* Enhanced outer glow with multiple layers */}
          <div className="absolute -inset-1 bg-gradient-to-r from-[#22D3EE]  via-[#2563EB] to-[#1D4ED8] rounded-3xl opacity-30 blur-xl animate-pulse"></div>
          <div className="absolute -inset-0.5 bg-gradient-to-r from-[#22D3EE] via-[#2563EB] to-[#1D4ED8] rounded-3xl opacity-40 blur-lg"></div>

          {/* Main card */}
          <div className="relative bg-gradient-to-br from-[#060E1C]/95 via-[#080F1C]/95 to-[#0B1E36]/95 backdrop-blur-xl border border-[#2563EB]/40 rounded-3xl px-3 py-12 shadow-2xl shadow-[#2563EB]/30 overflow-hidden">

            {/* Enhanced decorative background effects */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-bl from-[#2563EB]/10 via-[#2563EB]/5 to-transparent rounded-full blur-3xl"></div>
            <div className="absolute -bottom-10 -left-10 w-48 h-48 bg-gradient-to-tr from-[#2563EB]/10 via-[#2563EB]/5 to-transparent rounded-full blur-2xl"></div>

            {/* Enhanced decorative corners */}
            <div className="absolute top-0 right-0 w-32 h-32 border-t-2 border-r-2 border-gradient-to-bl from-[#2563EB]/30 to-[#2563EB]/30 rounded-tr-3xl"></div>
            <div className="absolute bottom-0 left-0 w-24 h-24 border-b-2 border-l-2 border-gradient-to-tr from-[#2563EB]/20 to-[#2563EB]/20 rounded-bl-3xl"></div>

            {/* Enhanced accent lines */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-[#22D3EE]  via-[#2563EB] to-[#1D4ED8] animate-pulse"></div>
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#2563EB]/50 to-transparent"></div>

            {/* Content */}
            <div className="relative z-10">
              {/* Enhanced Logo */}
              <div className="flex justify-center mb-8">
                <div className="relative group">
                  {/* Multi-layered logo glow effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-[#22D3EE]/40 to-[#2563EB]/40 rounded-2xl blur-3xl animate-pulse group-hover:scale-110 transition-transform duration-500"></div>
                  <div className="absolute inset-0 bg-[#2563EB]/20 rounded-2xl blur-xl animate-pulse" style={{ animationDelay: '0.5s' }}></div>

                  {/* Logo container */}
                  <div
                    onClick={() => navigate("/")}
                    className="relative flex items-center gap-3 cursor-pointer group-hover:scale-105 transition-all duration-500"
                  >
                    <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#22D3EE]/20 to-[#1D4ED8]/20 border border-[#2563EB]/50 shadow-[0_0_20px_rgba(37,99,235,0.25)] flex items-center justify-center overflow-hidden">
                      <img src={logo} alt="logo" className="w-7 h-7 object-contain relative z-10 drop-shadow-lg" />
                    </div>
                    <div className="flex flex-col leading-none">
                      <span className="text-base font-extrabold tracking-[0.05em] text-[#f3f4f6]">HEXAFUND</span>
                      <span className="mt-1 text-[10px] tracking-[0.14em] uppercase text-[#2563EB]">Crowd Funding</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Enhanced Heading */}
              <div className="text-center mb-10">
                <h2 className="text-transparent bg-clip-text bg-gradient-to-r from-[#22D3EE]  via-[#2563EB] to-[#1D4ED8] text-3xl font-bold mb-3 tracking-wide">
                  Create Account
                </h2>
                <p className="text-[#94A3B8] text-base font-medium">Welcome to the Forex Trading Platform with Advanced Features</p>

                {/* Enhanced decorative divider */}
                <div className="flex items-center justify-center gap-3 mt-6">
                  <div className="w-12 h-px bg-gradient-to-r from-transparent via-[#2563EB]/60 to-[#2563EB]/60"></div>
                  <div className="w-3 h-3 rounded-full bg-gradient-to-r from-[#22D3EE] to-[#2563EB] animate-pulse"></div>
                  <div className="w-12 h-px bg-gradient-to-l from-transparent via-[#2563EB]/60 to-[#2563EB]/60"></div>
                </div>
              </div>

              {/* Enhanced Form Fields */}
              <div className="space-y-4 mb-8">
                <input
                  type="text"
                  value={firstname}
                  onChange={(e) => setFirstname(e.target.value)}
                  placeholder="First Name"
                  className="w-full px-4 py-3 rounded-xl bg-[#071526]/80 border border-[#2563EB]/40 text-[#E2E8F0] text-sm placeholder-[#64748B] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB]"
                />
                <input
                  type="text"
                  value={lastname}
                  onChange={(e) => setLastname(e.target.value)}
                  placeholder="Last Name"
                  className="w-full px-4 py-3 rounded-xl bg-[#071526]/80 border border-[#2563EB]/40 text-[#E2E8F0] text-sm placeholder-[#64748B] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB]"
                />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email ID"
                  className="w-full px-4 py-3 rounded-xl bg-[#071526]/80 border border-[#2563EB]/40 text-[#E2E8F0] text-sm placeholder-[#64748B] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB]"
                />
                <div className="flex gap-2">
                  <div className="w-52">
                    <Autocomplete
                      size="small"
                      options={countryCodeOptions || []}
                      value={selectedCountry || null}
                      onChange={(_, newValue) => setCountryCode(newValue?.value || "")}
                      getOptionLabel={(option) => `${option?.countryName || ""} (${option?.cca2 || ""}) ${option?.value || ""}`}
                      isOptionEqualToValue={(option, value) => option?.value === value?.value}
                      renderOption={(props, option) => (
                        <li {...props}>
                          <div className="flex items-center gap-2">
                            {option?.flagPng ? (
                              <img
                                src={option.flagPng}
                                alt={option?.cca2 || "flag"}
                                className="w-5 h-4 rounded-sm object-cover"
                              />
                            ) : null}
                            <span>{option?.countryName} ({option?.cca2}) {option?.value}</span>
                          </div>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Search country"
                          sx={{
                            "& .MuiInputBase-root": {
                              backgroundColor: "rgba(7,21,38,0.8)",
                              color: "#E2E8F0",
                              borderRadius: "0.75rem",
                              minHeight: "48px",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "rgba(37,99,235,0.5)",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "rgba(37,99,235,0.5)",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#2563EB",
                            },
                            "& .MuiSvgIcon-root": {
                              color: "#2563EB",
                            },
                            "& input": {
                              color: "#E2E8F0",
                              fontSize: "0.875rem",
                            },
                            "& input::placeholder": {
                              color: "rgba(100,116,139,1)",
                              opacity: 1,
                            },
                          }}
                        />
                      )}
                      sx={{
                        "& .MuiAutocomplete-popupIndicator": {
                          color: "#2563EB",
                        },
                        "& .MuiAutocomplete-clearIndicator": {
                          color: "#2563EB",
                        },
                      }}
                    />
                  </div>
                  <input
                    type="text"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    placeholder="Mobile"
                    className="flex-1 px-4 py-3 rounded-xl bg-[#071526]/80 border border-[#2563EB]/40 text-[#E2E8F0] text-sm placeholder-[#64748B] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB]"
                  />
                </div>
                {/* <input
                  type="text"
                  value={mt5AccountId}
                  onChange={(e) => setMt5AccountId(e.target.value)}
                  placeholder="MT5 Account"
                  className="w-full px-4 py-3 rounded-xl bg-[#071526]/80 border border-[#2563EB]/40 text-[#E2E8F0] text-sm placeholder-[#64748B] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB]"
                /> */}
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  className="w-full px-4 py-3 rounded-xl bg-[#071526]/80 border border-[#2563EB]/40 text-[#E2E8F0] text-sm placeholder-[#64748B] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB]"
                />
                <input
                  type="password"
                  value={confirmpassword}
                  onChange={(e) => setConfirmpassword(e.target.value)}
                  placeholder="Confirm Password"
                  className="w-full px-4 py-3 rounded-xl bg-[#071526]/80 border border-[#2563EB]/40 text-[#E2E8F0] text-sm placeholder-[#64748B] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB]"
                />
                <input
                  type="text"
                  value={referral_id}
                  // onChange={(e) => setInvitationcode(e.target.value)}
                  placeholder="Invitation Code"
                  className="w-full px-4 py-3 rounded-xl bg-[#071526]/80 border border-[#2563EB]/40 text-[#E2E8F0] text-sm placeholder-[#64748B] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB]"
                />
                <input
                  type="text"
                  value={sponsername === "true" ? "Valid Referral" : sponsername}
                  // onChange={(e) => setSponsername(e.target.value)}
                  placeholder="Sponser Status"
                  className="w-full px-4 py-3 rounded-xl bg-[#071526]/80 border border-[#2563EB]/40 text-[#E2E8F0] text-sm placeholder-[#64748B] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB]"
                />
              </div>

              {/* Enhanced Sign Up Button */}
              <div className="mb-8">
                <button
                  onClick={loginFn}
                  disabled={!firstname || !lastname || !email || !mobile || !password || !confirmpassword || password !== confirmpassword}
                  className="relative w-full py-5 rounded-2xl font-bold text-lg overflow-hidden group transition-all duration-500 hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
                >
                  {/* Enhanced button background */}
                  <div className="absolute inset-0 bg-gradient-to-r from-[#1D4ED8] via-[#2563EB]  to-[#22D3EE] bg-size-200 bg-pos-0 group-hover:bg-pos-100 transition-all duration-700 disabled:opacity-50"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-[#22D3EE] via-[#2563EB] to-[#1D4ED8] opacity-0 group-hover:opacity-90 transition-opacity duration-500"></div>

                  {/* Enhanced button glow */}
                  <div className="absolute -inset-1 bg-gradient-to-r from-[#22D3EE] via-[#2563EB] to-[#1D4ED8] opacity-0 group-hover:opacity-80 transition-opacity duration-500 blur-xl rounded-2xl"></div>

                  {/* Button content */}
                  <span className="relative z-10 flex items-center justify-center gap-4 text-white">
                    <svg className="w-6 h-6 group-hover:rotate-12 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                    </svg>
                    Create Account
                    <svg className="w-6 h-6 group-hover:translate-x-2 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </span>

                  {/* Enhanced shine effect */}
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700">
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent -skew-x-12 translate-x-[-300%] group-hover:translate-x-[300%] transition-transform duration-1000"></div>
                  </div>
                </button>

                {/* Validation hint */}
                {((!firstname || !lastname || !email || !mobile || !password || !confirmpassword) || (password !== confirmpassword)) && (
                  <div className="mt-3 flex items-center gap-2 text-[#64748B] text-xs">
                    <svg className="w-4 h-4 text-[#22D3EE]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.664-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
                    </svg>
                    <span>
                      {password !== confirmpassword ? "Passwords do not match" : "Please fill all required fields"}
                    </span>
                  </div>
                )}
              </div>

              {/* Enhanced Divider */}
              <div className="flex items-center gap-4 my-8">
                <div className="flex-1 h-px bg-gradient-to-r from-transparent  via-[#2563EB]/40 to-transparent"></div>
                <span className="text-[#64748B] text-sm font-medium bg-[#071526]/80 px-4 py-2 rounded-full border border-[#1e3a5f]/80">OR</span>
                <div className="flex-1 h-px bg-gradient-to-l from-transparent  via-[#2563EB]/40 to-transparent"></div>
              </div>

              {/* Enhanced Login Link */}
              <div className="text-center mb-6">
                <p className="text-[#94A3B8] text-sm">
                  Already have an account?{" "}
                  <span
                    onClick={() => navigate("/login")}
                    className="text-transparent bg-clip-text bg-gradient-to-r from-[#22D3EE] via-[#2563EB] to-[#1D4ED8] font-bold cursor-pointer hover:from-[#2563EB] hover:via-[#1D4ED8] hover:to-[#2563EB] transition-all duration-300 inline-flex items-center gap-2 hover:scale-105"
                  >
                    Sign In
                    <svg className="w-4 h-4 text-[#2563EB] group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                    </svg>
                  </span>
                </p>
              </div>

              {/* Enhanced Security Badge */}
              <div className="flex items-center justify-center gap-3 text-[#64748B] text-xs bg-[#0B1E36]/50 backdrop-blur-sm rounded-full px-4 py-3 border border-[#132440]/60">
                <div className="p-1 bg-[#2563EB]/20 rounded-full">
                  <svg className="w-4 h-4 text-[#2563EB]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <span className="font-medium">Secured registration process</span>
              </div>
            </div>
          </div>
        </div>

        {/* Enhanced Custom Animations */}
        <style jsx>{`
        .bg-size-200 {
          background-size: 200% 100%;
        }
        .bg-pos-0 {
          background-position: 0% 0%;
        }
        .bg-pos-100 {
          background-position: 100% 0%;
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        
        @keyframes glow {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        
        .animate-glow {
          animation: glow 2s ease-in-out infinite;
        }
      `}</style>
      </div>
    </>
  );

};

export default Registration;
